import { getBooleanFromValue } from '@/global/utils/utils'

export default {
  computed: {
    prlSettingsEditConfig () {
      return {
        title: this.$t('fleet/documents/prl_cargo.prl_settings'),
        key: 'prlSettings',
        formData: this.formData?.item,
        onTabChange: () => {
          this.showMainEditButtons = true
        },
        editUpdate: (event) => {
          const { edit } = event || {}
          this.$set(this.disableTabs, 'canBus', edit)
          this.$set(this.disableTabs, 'readouts', edit)
          this.$set(this.disableTabs, 'documents', edit)
          this.$set(this.disableTabs, 'inspections', edit)
          this.$set(this.disableTabs, 'insurances', edit)
          this.$set(this.disableTabs, 'leasing', edit)
          this.$set(this.disableTabs, 'rangeLimits', edit)
          this.$set(this.disableTabs, 'serviceIntervals', edit)
          this.$set(this.disableTabs, 'serviceHistory', edit)
          this.$set(this.disableTabs, 'comments', edit)
          this.$set(this.disableTabs, 'damages', edit)
        },
        tabContent: [
          {
            title: this.$t('fleet/documents/prl_cargo.prl_settings'),
            component: this.columnsContentComponent,
            rows: [
              {
                disabled: !getBooleanFromValue(this.permissions?.canEdit),
                columnsCount: 4,
                fields: [
                  {
                    key: 'travel_document_type_id',
                    label: this.$t('fleet/documents/prl_cargo.prl_type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'travel-documents/document-type/autocomplete',
                      custom_display_value: (item) => {
                        return item && item.description ? item.description : null
                      }
                    },
                    visible: getBooleanFromValue(this.permissions?.canReadPrlDocumentTypeField),
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'transport_type_id',
                    label: this.$t('fleet/documents/prl_cargo.travel_type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'vehicle-transport-type/autocomplete',
                      custom_display_value: (item) => {
                        return item && item.description ? item.description : null
                      }
                    },
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'department_id',
                    label: this.$t('fleet.department'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'vehicle-department'
                    },
                    visible: getBooleanFromValue(this.permissions?.canReadDepartmentField),
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'organizational_unit_id',
                    label: this.$t('fleet.organizational_unit'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'vehicle-organizational-unit'
                    },
                    visible: getBooleanFromValue(this.permissions?.canReadPrlDocumentTypeField),
                    editable: true,
                    creatable: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
